import React from 'react'
import { MoonIcon, SunIcon } from '@heroicons/react/24/outline'
import { useTheme } from '@/contexts/ThemeContext'
import { useTar } from '@/modules'
import { Button } from '@duck/ui'
import { useSidebar } from '@duck/ui'

interface ThemeSelectorProps {
  className?: string
}

export const ThemeSelector: React.FC<ThemeSelectorProps> = ({ className = '' }) => {
  const { setTheme, isDark } = useTheme()
  const { t } = useTar()
  const { open } = useSidebar()

  const handleToggleTheme = () => {
    setTheme(isDark ? 'light' : 'dark')
  }

  return (
    <Button
      onClick={handleToggleTheme}
      variant="ghost"
      size="sm"
      className={`flex items-center hover:bg-accent/10 hover:text-foreground w-full text-muted-foreground justify-start`}
      title={isDark ? t('themes.light') : t('themes.dark')}
    >
      {!isDark ? (
        <SunIcon className="w-4 h-4" aria-hidden="true" />
      ) : (
        <MoonIcon className="w-4 h-4" aria-hidden="true" />
      )}
      {open && (
        <span className="ms-2 text-xs">{!isDark ? t('themes.lightMode') : t('themes.darkMode')}</span>
      )}
    </Button>
  )
}
